import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ComponentHelper} from '../helper/component.helper';
import {PreviewDocumentService} from '../service/preview-document.service';
import {NachdigalService, FrontendDocument, FrontendStatusEnum} from '@nachdigal';
import {UpdateDocumentService} from '../service/update-document.service';

@Injectable()
export class DocumentResolver implements Resolve<FrontendDocument> {

    constructor(private readonly documentService: NachdigalService,
                private readonly previewService: PreviewDocumentService,
                private readonly updateDocumentService: UpdateDocumentService,
                private readonly router: Router) {
    }

    public resolve(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<FrontendDocument> {
        const optionalParams: { [key: string]: string } = {};
        const taskId = route.paramMap.get('taskId');

        return this.documentService.getFrontendDocument(taskId).pipe(tap((data: FrontendDocument) => {
            this.updateDocumentService.changeDocument(data);
            if (data.status === FrontendStatusEnum.SendingSuccessful) {
                this.previewService.displayPdfData(taskId, true);
                this.router.navigate(['']).then(() => {}).catch(() => {});
            } else {
                const appName = data?.element_of_order?.app_name;
                if (appName) {
                    const appEnum = ComponentHelper.getAppEnum(route);
                    optionalParams.ft = routerState.url;
                    optionalParams.rurl = appName;
                    if (appName !== appEnum) {
                        this.router.navigate(['forbidden', '403', optionalParams]).then(() => {}).catch(() => {});
                    }
                }
            }
        }));
    }
}
